export const SET_SELECTED_SETUP = "SET_SELECTED_SETUP";
export const setSelectedSetup = (selectedSetup: string) => ({
  type: SET_SELECTED_SETUP,
  payload: selectedSetup,
});
